import * as storeConst from "./constants";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";
import { EventBus } from "@/event-bus";
import { makeCall } from "@/utils/request";
import { buildOptions, getEndPoints } from "@/utils/api-call";
import messages from "@/locales/index";

export const state = {
  cohorts: {
    data: [],
    pagination: {
      current_page: 1,
      per_page: 5,
      count: 0,
      total: 0,
      total_pages: 0
    }
  },
  collections: []
};

export const getters = {
  [storeConst.GETTERS_COHORTS]: state => {
    return state.cohorts;
  },
  [storeConst.GETTERS_COLLECTIONS]: state => {
    return state.collections;
  }
};

export const actions = {
  [storeConst.ACTIONS_GET_COHORTS]: ({ commit }, options) => {
    const url = getEndPoints().programCohort.getCohorts.replace(
      ":programId",
      options.programId
    );
    makeCall(url, buildOptions("GET", options), commit)
      .then(response => {
        commit(storeConst.MUTATIONS_SET_COHORTS, response);
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          error.response.data.error.message.title || error
        );
      });
  },
  [storeConst.ACTIONS_ADD_COHORTS]: ({ commit }, options) => {
    const url = getEndPoints().programCohort.addCohort;
    makeCall(url, buildOptions("POST", options.data), commit)
      .then(response => {
        EventBus.$emit(EVENT_TOAST_MESSAGE, messages.getLocalizedString('changesSavedSuccessfully'));
        if (options.callback) {
          options.callback(response);
        }
      })
      .catch(function(error) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          error.response.data.error.message.message || error
        );
      });
  },
  [storeConst.ACTIONS_REMOVE_COHORT]: ({ commit }, options) => {
    const url = getEndPoints().programCohort.removeCohort.replace(
      ":id",
      options.id
    );
    makeCall(url, buildOptions("DELETE", {}), commit)
      .then(response => {
        EventBus.$emit(EVENT_TOAST_MESSAGE, "Delete cohort successfully");
        if (options.callback) {
          options.callback(response);
        }
      })
      .catch(function(error) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          error.response.data.error.message.title || error
        );
        options.callback(error);
      });
  },
  [storeConst.ACTIONS_GET_COLLECTIONS]: ({ commit }, options) => {
    const url = getEndPoints().programCohort.getCollections.replace(
      ":programId",
      options.programId
    );
    makeCall(url, buildOptions("GET", options), commit)
      .then(response => {
        commit(storeConst.MUTATIONS_SET_COLLECTIONS, response);
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          error.response.data.error.message.title || error
        );
      });
  },
  [storeConst.ACTIONS_REMOVE_COLLECTION]: ({ commit }, options) => {
    const url = getEndPoints().programCohort.removeCollection.replace(
      ":id",
      options.id
    );
    makeCall(url, buildOptions("DELETE", {}), commit)
      .then(response => {
        EventBus.$emit(EVENT_TOAST_MESSAGE, "Delete collection successfully");
        if (options.callback) {
          options.callback(response);
        }
      })
      .catch(function(error) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          error.response.data.error.message.title || error
        );
        options.callback(error);
      });
  },
  [storeConst.ACTIONS_GET_COLLECTIONS_BY_ID]: ({ commit }, options) => {
    const url = getEndPoints().programCohort.getCollectionListById;
    makeCall(url, buildOptions("GET", options), commit)
      .then(response => {
        commit(storeConst.MUTATIONS_SET_COLLECTIONS, response);
        if (options.callback) {
          options.callback(response);
        }
      })
      .catch(function(error) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          error.response.data.error.message.title || error
        );
        options.callback(error);
      });
  }
};

export const mutations = {
  [storeConst.MUTATIONS_SET_COHORTS]: (state, payload) => {
    if (payload) {
      state.cohorts = payload;
    }
  },
  [storeConst.MUTATIONS_SET_COLLECTIONS]: (state, payload) => {
    if (payload) {
      state.collections = payload;
    }
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_cohorts/index.js